// Header button that cycles the checklist/list/template text size through
// normal -> large -> x-large -> xx-large -> xxx-large (accessibility).
// Shared between AppLayout
// (signed-in chrome) and the bare ResourceShell header (anonymous share-link
// visitors) so both surfaces offer it - see hooks/useFontScale.ts.
import { ALargeSmall } from "lucide-react";

import { FONT_SCALE_LABELS, nextFontScale, type FontScale } from "../lib/displayPrefs.js";

export function FontScaleToggle({
  scale,
  onCycle,
  className = "",
}: {
  scale: FontScale;
  onCycle: () => void;
  className?: string;
}) {
  const next = nextFontScale(scale);
  return (
    <button
      type="button"
      className={[
        "inline-flex shrink-0 items-center gap-1 rounded-lg p-2 text-muted transition hover:bg-slate-100 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40",
        scale !== "normal" ? "text-brand-700" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={`Text size: ${FONT_SCALE_LABELS[scale]}. Tap to switch to ${FONT_SCALE_LABELS[next]}.`}
      title={`Text size: ${FONT_SCALE_LABELS[scale]}`}
      onClick={onCycle}
    >
      <ALargeSmall size={20} aria-hidden="true" />
    </button>
  );
}
